import React from 'react';
import { BookOpenIcon, GiftIcon } from 'lucide-react';
import { Section } from './Shared';
import { KanjiBackdrop } from './Ornaments';
import { bonuses, tomes } from '../data/bonuses';
const kitCoverUrl = 'https://cdn.magicpatterns.com/uploads/gzAsXPZjQLXLmHKXYJ47gw/Portada_de_cuaderno_espiral_con_paisaje.png';
const packStats = [{
  value: '6 tomos',
  label: '300 páginas'
}, {
  value: '3 bonus',
  label: '150 páginas'
}, {
  value: '450',
  label: 'páginas en total'
}];
export function PackContents() {
  return <Section id="contenido" className="relative" data-id="element-136" data-mp="irvsa9pi0de9">
      <KanjiBackdrop glyphs={['經', '絡', '五', '行', '道']} data-id="element-137" data-mp="440voi8ddovw" />
      <div className="mx-auto max-w-4xl text-center" data-id="element-138" data-mp="4397vtl0kvg6">
        <h2 className="flex items-center justify-center gap-2 text-[28px] font-bold leading-tight tracking-tight text-stone-900 sm:text-4xl md:text-5xl" data-id="element-139" data-mp="92ucokmv7y0t">
          <BookOpenIcon className="h-6 w-6 shrink-0 text-amber-700 md:h-8 md:w-8" aria-hidden="true" data-id="element-140" data-mp="wrdimtifzypq" />
          MIRÁ EL KIT POR DENTRO
        </h2>

        <div className="relative mx-auto mt-5 w-full max-w-[300px] sm:max-w-[360px] md:mt-6" data-id="element-141" data-mp="3p6uzeeqknmum">
          {/* Botones laterales del celular */}
          <span className="absolute -left-[3px] top-[18%] h-10 w-[3px] rounded-l-sm bg-stone-700" aria-hidden="true" data-id="element-142" data-mp="3k9uva9da8u65" />
          <span className="absolute -left-[3px] top-[28%] h-14 w-[3px] rounded-l-sm bg-stone-700" aria-hidden="true" data-id="element-143" data-mp="2twhwebdw2p6" />
          <span className="absolute -right-[3px] top-[24%] h-16 w-[3px] rounded-r-sm bg-stone-700" aria-hidden="true" data-id="element-144" data-mp="bshtfpifuhgg" />
          <div className="rounded-[2.75rem] bg-stone-900 p-2.5 shadow-2xl ring-1 ring-stone-700 sm:p-3" data-id="element-145" data-mp="6twuruiu45u4">
            <div className="relative overflow-hidden rounded-[2.1rem] bg-black" data-id="element-146" data-mp="lqxna08uo4tn">
              <span className="absolute left-1/2 top-2.5 z-10 h-6 w-24 -translate-x-1/2 rounded-full bg-black" aria-hidden="true" data-id="element-147" data-mp="grujej4lw4n9" />
              <video autoPlay loop muted playsInline preload="metadata" className="block w-full" aria-label="Muestra en scroll de las páginas del ebook del Kit Medicina Tradicional China" data-id="element-148" data-mp="2nj2e18em4w2s">
                <source src="https://cdn.magicpatterns.com/uploads/pMXYuT8H3T7DayRcpP9GqB/Scroll_molde_optimizado.mp4" type="video/mp4" data-id="element-149" data-mp="3884wp8qxdcjo" />
                Tu navegador no soporta la reproducción de videos.
              </video>
            </div>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-2xl text-lg font-semibold leading-snug text-stone-900 md:text-xl" data-id="element-150" data-mp="3m6l3ezosf31t">
          Una biblioteca visual para continuar estudiando, repasar conceptos y{' '}
          <span className="text-red-700" data-id="element-151" data-mp="3v7j7fhz87ake">descubrir nuevas conexiones</span>{' '}
          entre las distintas ramas de la Medicina China.
        </p>
        
      </div>

      <div className="mx-auto mt-6 max-w-5xl rounded-xl border border-stone-200 bg-white p-4 shadow-sm md:p-6" data-id="element-152" data-mp="3tn5szfgwmat">
        <div className="flex items-center gap-4 md:gap-6" data-id="element-153" data-mp="8tstk4im9onm">
          <img src={kitCoverUrl} alt="Portada del Kit Medicina Tradicional China" className="w-24 shrink-0 object-contain mix-blend-multiply drop-shadow-md sm:w-28 md:w-36" loading="lazy" decoding="async" data-id="element-154" data-mp="dscf43tasyfg" />
          <div className="min-w-0" data-id="element-155" data-mp="239rirj7648ms">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-red-700" data-id="element-156" data-mp="235u00yoi5j3f">
              El pack principal
            </span>
            <h3 className="mt-0.5 text-lg font-bold leading-tight tracking-tight text-stone-900 sm:text-xl md:text-2xl" data-id="element-157" data-mp="1tb1xrhjz682b">
              KIT MEDICINA TRADICIONAL CHINA™
            </h3>
            <p className="mt-1.5 max-w-2xl text-sm leading-snug text-stone-600 md:text-base" data-id="element-158" data-mp="2lz7nkipvyn90">
              Una biblioteca visual de estudio para terapeutas y practicantes con
              formación previa que quieren ampliar sus conocimientos y explorar
              distintas ramas de la Medicina China.
            </p>
            <p className="mt-2 text-[10px] font-bold uppercase tracking-[0.1em] text-emerald-700 md:text-xs" data-id="element-159" data-mp="2790dordy2cjx">
              {packStats.map(stat => `${stat.value} · ${stat.label}`).join('  |  ')}
            </p>
          </div>
        </div>

        <ul className="mt-4 grid gap-x-6 gap-y-3 border-t border-stone-200 pt-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-160" data-mp="2zwmclmc88t0g">
          {tomes.map(tome => <li key={tome.label} className="flex gap-3" data-id="element-161" data-mp="2pg257ug16vob">
              <img src={tome.cover} alt={`Portada del ${tome.label}: ${tome.title}`} loading="lazy" decoding="async" className="aspect-[3/4] w-10 shrink-0 self-start rounded border border-stone-300 bg-stone-900 object-cover shadow-sm md:w-12" data-id="element-162" data-mp="2pdfvpp9ky63g" />
              <div className="min-w-0" data-id="element-163" data-mp="336nm5dlxcvjk">
                <p className="text-[13px] font-bold leading-snug text-stone-900" data-id="element-164" data-mp="337p9ohk4nai6">
                  <span className="uppercase tracking-[0.06em] text-red-700" data-id="element-165" data-mp="384p949mh1f0b">
                    {tome.label}
                  </span>{' '}
                  — {tome.title}
                </p>
                <p className="mt-0.5 text-xs leading-snug text-stone-500" data-id="element-166" data-mp="2yew6hy4b4a87">
                  {tome.description}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mt-4 border-t border-stone-200 pt-3 text-xs leading-relaxed text-stone-500 md:text-center" data-id="element-167" data-mp="3qwroziragr9i">
          Una biblioteca para recorrer distintas áreas de la Medicina China con
          contenidos de estudio y recursos visuales para seguir aprendiendo.
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-5xl rounded-xl border border-stone-200 bg-white p-5 shadow-sm md:p-6" data-id="element-168" data-mp="1p7luyvkllvau">
        <div className="flex flex-col items-center gap-2 border-b border-stone-200 pb-4 text-center sm:flex-row sm:justify-between sm:text-left" data-id="element-169" data-mp="1k9an2qdv5uv9">
          <h3 className="flex items-center gap-2 text-lg font-bold tracking-tight text-stone-900 md:text-xl" data-id="element-170" data-mp="wkhxdbnu4j93">
            <GiftIcon className="h-5 w-5 text-amber-700" aria-hidden="true" data-id="element-171" data-mp="15jd54s6j21ei" />
            3 BONOS DE ESTUDIO — <span className="text-emerald-700" data-id="element-172" data-mp="11hrl8mvksmut">GRATIS</span>
          </h3>
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-stone-500" data-id="element-173" data-mp="11jujfu6vtmam">
            150 páginas adicionales · Sin costo extra
          </p>
        </div>
        <ul className="mt-4 grid gap-4 md:grid-cols-3 md:gap-6" data-id="element-174" data-mp="2cw53nc7k8a3g">
          {bonuses.map(bonus => <li key={bonus.n} className="flex items-start gap-3" data-id="element-175" data-mp="19ky1ln8vnx0y">
              <img src={bonus.cover} alt={`Portada del bonus ${bonus.n}: ${bonus.title}`} loading="lazy" decoding="async" className="aspect-[3/4] w-16 shrink-0 object-contain mix-blend-multiply drop-shadow-md md:w-20" data-id="element-176" data-mp="1eku5lmhkrogi" />
              <div className="min-w-0" data-id="element-177" data-mp="1nm23w4k3cpal">
                <p className="text-[11px] font-bold uppercase tracking-wide text-red-700" data-id="element-178" data-mp="1nkza9ovdw8qz">
                  Bonus {bonus.n}
                </p>
                <p className="mt-0.5 text-sm font-semibold leading-snug text-stone-900" data-id="element-179" data-mp="vu2xspd8k648">
                  {bonus.title}
                </p>
                <p className="mt-1 text-xs leading-relaxed text-stone-500" data-id="element-180" data-mp="zumx9zla7ltj">
                  {bonus.description}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </Section>;
}